"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _usePalette2 = _interopRequireDefault(require("../styles/PaletteProvider/usePalette"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      colors = _useTheme.colors,
      fonts = _useTheme.fonts;

  var _usePalette = (0, _usePalette2["default"])(),
      typography = _usePalette.typography;

  var paragraph = typography.paragraph,
      paragraphEmphasis = typography.paragraphEmphasis,
      inactive = typography.inactive;
  return {
    root: {
      color: colors[paragraph],
      strong: {
        fontWeight: 'bold',
        color: colors[paragraphEmphasis]
      }
    },
    inactive: {
      color: colors[inactive]
    },
    paragraph: fonts.primary,
    secondary: fonts.secondaryDefault,
    tertiary: fonts.tertiaryDefault
  };
};

__signature__(useStyles, "useTheme{{ colors, fonts }}\nusePalette{{ typography }}", function () {
  return [_useTheme2["default"], _usePalette2["default"]];
});

var Paragraph = function Paragraph(props) {
  var _props$as = props.as,
      Element = _props$as === void 0 ? 'span' : _props$as,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'paragraph' : _props$variant,
      inactive = props.inactive,
      other = (0, _objectWithoutProperties2["default"])(props, ["as", "variant", "inactive"]);
  var classes = useStyles();
  return (0, _core.jsx)(Element, (0, _extends2["default"])({
    css: /*#__PURE__*/(0, _css2["default"])([classes.root, inactive && classes.inactive, classes[variant]], ";label:Paragraph;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9UZXh0L1BhcmFncmFwaC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMkNrQiIsImZpbGUiOiIuLi8uLi9zcmMvVGV4dC9QYXJhZ3JhcGgudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgQ1NTT2JqZWN0IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbmltcG9ydCB1c2VQYWxldHRlIGZyb20gJy4uL3N0eWxlcy9QYWxldHRlUHJvdmlkZXIvdXNlUGFsZXR0ZSc7XG5pbXBvcnQgdXNlVGhlbWUgZnJvbSAnLi4vc3R5bGVzL3VzZVRoZW1lJztcbmltcG9ydCB7IEdlbmVyaWNDb21wb25lbnQsIFdpdGhBc1Byb3AgfSBmcm9tICcuLi90eXBlcy93aXRoLWFzLXByb3AnO1xuXG5leHBvcnQgdHlwZSBQYXJhZ3JhcGhWYXJpYW50ID0gJ3BhcmFncmFwaCcgfCAnc2Vjb25kYXJ5JyB8ICd0ZXJ0aWFyeSc7XG5cbmV4cG9ydCB0eXBlIFBhcmFncmFwaFByb3BzPFQgZXh0ZW5kcyBHZW5lcmljQ29tcG9uZW50ID0gJ3NwYW4nPiA9IFdpdGhBc1Byb3A8VD4gJiB7XG4gIHZhcmlhbnQ/OiBQYXJhZ3JhcGhWYXJpYW50O1xuICBpbmFjdGl2ZT86IGJvb2xlYW47XG59O1xuXG5jb25zdCB1c2VTdHlsZXMgPSAoKTogQ1NTT2JqZWN0ID0+IHtcbiAgY29uc3QgeyBjb2xvcnMsIGZvbnRzIH0gPSB1c2VUaGVtZSgpO1xuXG4gIGNvbnN0IHsgdHlwb2dyYXBoeSB9ID0gdXNlUGFsZXR0ZSgpO1xuICBjb25zdCB7IHBhcmFncmFwaCwgcGFyYWdyYXBoRW1waGFzaXMsIGluYWN0aXZlIH0gPSB0eXBvZ3JhcGh5O1xuXG4gIHJldHVybiB7XG4gICAgcm9vdDoge1xuICAgICAgY29sb3I6IGNvbG9yc1twYXJhZ3JhcGhdLFxuICAgICAgc3Ryb25nOiB7XG4gICAgICAgIGZvbnRXZWlnaHQ6ICdib2xkJyxcbiAgICAgICAgY29sb3I6IGNvbG9yc1twYXJhZ3JhcGhFbXBoYXNpc10sXG4gICAgICB9LFxuICAgIH0sXG4gICAgaW5hY3RpdmU6IHtcbiAgICAgIGNvbG9yOiBjb2xvcnNbaW5hY3RpdmVdLFxuICAgIH0sXG4gICAgcGFyYWdyYXBoOiBmb250cy5wcmltYXJ5LFxuICAgIHNlY29uZGFyeTogZm9udHMuc2Vjb25kYXJ5RGVmYXVsdCxcbiAgICB0ZXJ0aWFyeTogZm9udHMudGVydGlhcnlEZWZhdWx0LFxuICB9O1xufTtcblxuY29uc3QgUGFyYWdyYXBoID0gPFQgZXh0ZW5kcyBHZW5lcmljQ29tcG9uZW50ID0gJ3NwYW4nPihwcm9wczogUGFyYWdyYXBoUHJvcHM8VD4pID0+IHtcbiAgY29uc3QgeyBhczogRWxlbWVudCA9ICdzcGFuJywgdmFyaWFudCA9ICdwYXJhZ3JhcGgnLCBpbmFjdGl2ZSwgLi4ub3RoZXIgfSA9IHByb3BzO1xuXG4gIGNvbnN0IGNsYXNzZXMgPSB1c2VTdHlsZXMoKTtcblxuICByZXR1cm4gPEVsZW1lbnQgY3NzPXtbY2xhc3Nlcy5yb290LCBpbmFjdGl2ZSAmJiBjbGFzc2VzLmluYWN0aXZlLCBjbGFzc2VzW3ZhcmlhbnRdXX0gey4uLm90aGVyfSAvPjtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFBhcmFncmFwaDtcbiJdfQ== */"))
  }, other));
};

__signature__(Paragraph, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Paragraph;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Paragraph.tsx");
  reactHotLoader.register(Paragraph, "Paragraph", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Paragraph.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Paragraph.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();